/* cart-drawer.js */

document.addEventListener("DOMContentLoaded", () => {
  const drawer = document.querySelector("[data-cart-drawer]");
  if (!drawer) return;

  const body = drawer.querySelector("[data-cart-drawer-body]");
  const closeButtons = drawer.querySelectorAll("[data-cart-drawer-close]");

  const open = () => { drawer.hidden = false; document.body.style.overflow = "hidden"; };
  const close = () => { drawer.hidden = true; document.body.style.overflow = ""; };

  closeButtons.forEach(btn => btn.addEventListener("click", close));
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") close(); });

  // Open the drawer whenever store.js successfully adds an item.
  document.addEventListener("cart:updated", async () => {
    await refreshDrawer();
    open();
  });

  async function refreshDrawer() {
    try {
      const res = await fetch(`${window.location.pathname}?section_id=cart-drawer`);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      const newBody = doc.querySelector("[data-cart-drawer-body]");
      const newCount = doc.querySelector("[data-cart-count]");
      const newSubtotal = doc.querySelector("[data-cart-subtotal]");
      if (newBody) body.innerHTML = newBody.innerHTML;
      if (newCount) drawer.querySelector("[data-cart-count]").textContent = newCount.textContent;
      if (newSubtotal) drawer.querySelector("[data-cart-subtotal]").textContent = newSubtotal.textContent;
      updateHeaderCartCount(newCount ? newCount.textContent : null);
    } catch (err) {
      // Fallback: pull totals from /cart.js if section rendering isn't wired up yet.
      const cart = await fetch("/cart.js").then(r => r.json());
      updateHeaderCartCount(cart.item_count);
    }
  }

  function updateHeaderCartCount(count) {
    const badge = document.getElementById("cartCount");
    if (badge && count !== null) {
      badge.textContent = count;
      const bubble = badge.closest(".cart-count-bubble");
      if (bubble) bubble.classList.toggle("hidden", Number(count) === 0);
    }
  }

  body.addEventListener("click", async (e) => {
    const line = e.target.closest("[data-cart-line]");
    if (!line) return;
    const key = line.dataset.lineKey;
    const qtyEl = line.querySelector("[data-qty-value]");
    let qty = parseInt(qtyEl.textContent, 10);

    if (e.target.closest("[data-qty-increase]")) qty += 1;
    else if (e.target.closest("[data-qty-decrease]")) qty = Math.max(0, qty - 1);
    else if (e.target.closest("[data-cart-remove]")) qty = 0;
    else return;

    line.style.opacity = "0.5";
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    await refreshDrawer();
  });

  // Expose so other scripts (e.g. a header cart icon) can open it directly.
  window.openCartDrawer = open;
  const cartTrigger = document.getElementById("cart-icon-bubble") || document.getElementById("cartCount")?.closest("a");
  cartTrigger?.addEventListener("click", (e) => {
    e.preventDefault();
    refreshDrawer().then(open);
  });
});
